<h1>Vendor Management</h1>

<form *ngIf="vendor$ | async as T; else loading" [formGroup]="formGroup" novalidate>
    <mat-card appearance="outlined">
        <mat-card-content fxLayout="column">

            <h2>{{formGroup.controls.VendorName.value == '' ? "Vendor" : formGroup.controls.VendorName.value}}</h2>

            <div fxLayout="row wrap" fxLayoutGap.gt-sm="16px" fxLayout.lt-md="column">

                <mat-form-field appearance="outline" fxFlex="32" fxFlex.lt-md="auto">
                    <mat-label>Vendor Name</mat-label>
                    <input matInput type="text" formControlName="VendorName" />
                    <mat-error *ngIf="formGroup.controls.VendorName.hasError('required')">
                        Vendor Name is required
                    </mat-error>
                    <mat-error *ngIf="formGroup.controls.VendorName.hasError('invalid')">
                        {{formGroup.controls.VendorName.getError('invalid')}}
                    </mat-error>
                    <mat-error *ngIf="formGroup.controls.VendorName.status=='INVALID'">
                        {{formGroup.controls.VendorName.errors!['maxlength'] && 'Maximum length can be' + formGroup.controls.VendorName.errors!['maxlength']['requiredLength'] + '.'}}
                    </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" *ngIf="vendorId != '0'" fxFlex="32" fxFlex.lt-md="auto">
                    <mat-label>Id</mat-label>
                    <input matInput formControlName="Id" readonly>
                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex="32" fxFlex.lt-md="auto">
                    <mat-label>Client Key</mat-label>
                    <input matInput type="text" formControlName="ClientKey" />
                    <mat-error *ngIf="formGroup.controls.ClientKey.hasError('required')">
                        Client key is required
                    </mat-error>
                    <mat-error *ngIf="formGroup.controls.ClientKey.hasError('invalid')">
                        {{formGroup.controls.ClientKey.getError('invalid')}}
                    </mat-error>
                    <mat-error *ngIf="formGroup.controls.ClientKey.status=='INVALID'">
                        {{formGroup.controls.ClientKey.errors!['maxlength'] && 'Maximum length can be' + formGroup.controls.ClientKey.errors!['maxlength']['requiredLength'] + '.'}}
                    </mat-error>
                </mat-form-field>

            </div>
        </mat-card-content>
        <mat-card-actions>
            <div fxLayout="row" [fxLayoutAlign]="vendorId != '0'?'space-between':'end'" class="mat-card-actions-details">
                <button mat-raised-button type="button" color="warn" (click)="deleteRecord()" *ngIf="vendorId != '0'">
                    Delete
                </button>
                <div>
                    <button mat-stroked-button type="reset" (click)="cancel()">
                        Cancel
                    </button>
                    <button mat-raised-button type="button" (click)="save() " [disabled]="formGroup.invalid"
                        color="accent">
                        Save
                    </button>
                </div>
            </div>
        </mat-card-actions>
    </mat-card>
</form>

<ng-template #loading>
    <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
</ng-template>